import { render, staticRenderFns } from "./PaymentButton.vue?vue&type=template&id=c6e11c80&scoped=true&"
import script from "./PaymentButton.vue?vue&type=script&lang=js&"
export * from "./PaymentButton.vue?vue&type=script&lang=js&"
import style0 from "./PaymentButton.vue?vue&type=style&index=0&id=c6e11c80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6e11c80",
  null
  
)

export default component.exports